<script>
  import { slide } from 'svelte/transition';
  export let value;
  export let disabled = '';
  let btnName = 'Show embed code';
  let btnNameOpen = 'Hide embed code';
  let isOpen = false;
  const toggle = () => (isOpen = !isOpen);
</script>

<button on:click={toggle} aria-expanded={isOpen} class={disabled}
  >{isOpen ? btnNameOpen : btnName}
  <svg
    width="12"
    height="12"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
    stroke="currentColor"
    ><path d="M9 5l7 7-7 7" />
  </svg>
</button>
{#if isOpen}
  <div class="embed-code" transition:slide={{ duration: 300 }}>
    <textarea readonly>{value}</textarea>
  </div>
{/if}

<style>button{background:#f0f8ff;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-top:1px solid #d0d0d2;color:var(--h-c);cursor:pointer;display:block;font-size:1rem;padding-bottom:.5em;padding-top:.5em;text-align:center;width:100%}.disabled{color:#f0f8ff;pointer-events:none}.disabled,.disabled>svg{display:none}svg{transform:rotate(90deg);transition:transform .2s ease-in}[aria-expanded=true] svg{transform:rotate(270deg)}textarea{border:1px solid #d0d0d2;border-radius:3px;display:block;min-height:220px;resize:none;width:100%}.embed-code{background-color:#f0f8ff;border-bottom-left-radius:4px;border-bottom-right-radius:4px;bottom:0;padding:0 1em 1em;position:absolute;transform:translateY(100%);width:100%;z-index:3}</style>
